export default function getLevel(node, parentNode) {
  const isDifferentInNode =
    parentNode &&
    parentNode.type.endsWith("Node") &&
    node.type.endsWith("Atom") &&
    node.level !== parentNode.level;
  const level = node.path ? node.path.split("[").length - 1 : 999;
  return level + (isDifferentInNode ? 1 : 0); // + (inList ? 1 : 0);
}
